const StateMachineErrorCodes = {
  STM0001: 'Item is not in status that allows this action.',
} as const;

export default StateMachineErrorCodes;
